import { makeStyles } from 'tss-react/mui';

import theme from '@src/theme/theme';

import { dFlex } from '@assets/mixins';

export const styleBox = {
  position: 'absolute' as const,
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 670,
};

export const styleChildren = {
  background: theme.palette.custom.background.medium,
  padding: '24px',
  borderRadius: theme.borderRadius.xlg,
  boxShadow: '0px 1px 60px 0px #0AD9D133',
  border: `1px solid ${theme.palette.custom.border.primary}`,
};

export const styleClose = {
  display: 'flex',
  marginLeft: 'auto',
  color: theme.palette.custom.buttons.textSecondary,
  width: 32,
  height: 32,
};

export const styleHeader = {
  ...dFlex('center', 'center'),
  paddingBottom: '16px',
  position: 'relative',

  '> button': {
    position: 'absolute',
    right: 0,
  },
};

export const styleBackdrop = {
  '& .MuiModal-backdrop': {
    background: '#0F0F0FB2',
  },
};
